export const RESERVED_SLUGS = new Set([
  "admin", "api", "dashboard", "settings", "account", "login", "signup",
  "register", "auth", "pricing", "blog", "help", "support", "contact",
  "about", "terms", "privacy", "legal", "refer", "referral", "referrals",
  "partners", "partner", "structspectrum", "quotes", "clients", "billing",
  "subscribe", "subscription", "withdraw", "withdrawals", "wallet",
  "profile", "users", "user", "me", "health", "www", "app", "static",
  "assets", "favicon", "robots", "sitemap", "public", "files", "uploads",
  "shared", "share", "site-surveys", "cost-library", "adjustments",
  "pricing-intelligence", "referral-terms", "thank-you", "comparisons",
  "alternatives", "cookies", "maintenance", "inbox", "q", "ping", "track",
  "theme", "invite", "join", "welcome", "new",
  "quoting-software-for-builders", "construction-estimating-software",
  "best-quoting-software", "quoting-app-for-builders",
  "quoting-software-for-builders-uk", "construction-estimating-software-uk",
  "best-quoting-software-uk", "quoting-app-for-builders-uk",
  "for-small-builders", "for-sole-traders", "ai-quoting-software-uk",
  "buildxact-alternative", "estimatorxpress-alternative", "simpro-alternative",
  "fergus-alternative", "estimage-alternative", "pricejob-alternative",
  "buildern-alternative", "cubit-alternative", "evaluate-alternative",
  "quintadena-alternative", "easyestimate-alternative",
]);

export function isValidSlugFormat(slug: string): boolean {
  if (slug.length < 3 || slug.length > 30) return false;
  if (!/^[a-z0-9][a-z0-9-]*[a-z0-9]$/.test(slug)) return false;
  if (slug.includes("--")) return false;
  return true;
}

export function slugifyCompanyName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 30)
    .replace(/^-+|-+$/g, "");
}
